import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Toast as PrimeToast } from "primereact/toast";


const Toast = () => {
    const toastDetails = useSelector((state) => state.toast.toastDetails)

    const toast = useRef(null)

    useEffect(() => {
		toast.current.show(toastDetails)
	}, [toastDetails])

    return (
        <div>
            <PrimeToast ref={toast} />
        </div> 
    )
}

export default Toast;